import { useLoadScript } from "@react-google-maps/api";

/**
 * One set of Google Maps loader options for the whole app.
 *
 * @react-google-maps/api keeps a single <script> tag per page and warns — then
 * reloads the script — if a second caller asks for different options. The map
 * panel and the message panel's GPS view can be mounted at the same time, so
 * every caller has to ask for exactly the same thing.
 */

export const googleMapsApiKey = "AIzaSyDgNagv_ozKWc6IQ75Ol4cH8fxdntOaW6M";
export const googleMapsLibraries: any = ["places", "geometry", "drawing"];
export const googleMapsIds = ["bc10cdbc8ba6566d"];

/** Where the map opens when nothing else has been resolved yet. */
export const DEFAULT_MAP_CENTER = { lat: 40.756795, lng: -73.954298 };

export const useBeamMapsScript = () =>
  useLoadScript({
    googleMapsApiKey,
    libraries: googleMapsLibraries,
    mapIds: googleMapsIds,
    // DrawingManager was removed from the Maps JS API in v3.65
    // (https://developers.google.com/maps/deprecations). Pin to 3.64,
    // the last version that still ships it, until we migrate off it.
    version: "3.64",
  });
